/** Bump when Terms or Privacy materially change (stored with signup / checkout). */
export const LEGAL_DOCS_VERSION = "2026-05-12";

export const LEGAL_PATHS = {
  terms: "/legal/terms-of-use",
  privacy: "/legal/privacy-policy",
};
